const Merchant = {
  BONFIRE: 'BONFIRE',
  ZBAG: 'ZBAG',
  MGB_GGB: 'MGB_GGB',
};

export default Merchant;



// WEBPACK FOOTER //
// ./src/views/skidata/components/merchant.js